import { Role } from "@linkfluence/models/role";
import { useContextualProjectUserData } from "./useContextualProjectUserData";

export function useContextualProjectUserRole() {
  const data = useContextualProjectUserData();
  return data ? data.role : Role.Reader;
}
